import React from 'react';
import PropTypes from 'prop-types';
import ProcessField from 'components/core/fields/ProcessField';
import RIEInput from 'components/core/editable/RIEInput';
import ProcessUtils from 'utils/ProcessUtils';


export default class InputDatasetNameField extends ProcessField {
    static propTypes = Object.assign({
        inputDatasetName: PropTypes.string.isRequired,
        isFullWidth: PropTypes.bool
    }, ProcessField.propTypes);

    static defaultProps = {
        isFullWidth: true
    };

    onInputDatasetNameChange = (fieldPath, fieldValue, onChangeData) => {
        const editor = ProcessUtils.getEditor(this.props.process);
        editor.renameInputDataset(onChangeData.oldName, fieldValue);
        editor.commit();
    };

    render() {
        return (
            <RIEInput
                value={this.props.inputDatasetName}
                fieldPath={['variable_retrieval', 'input_datasets', this.props.inputDatasetName, 'name']}
                change={this.onInputDatasetNameChange}
                onChangeData={{ oldName: this.props.inputDatasetName }}
                checkUnique={{
                    list: Object.keys(this.props.process.variable_retrieval.input_datasets),
                    label: 'rule set'
                }}
                isDisabled={!this.props.hasWritePermissions}
                processId={this.props.process.name}
                processErrors={this.props.processErrors}
                isFullWidth={this.props.isFullWidth}
            />
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/core/fields/InputDatasetNameField.js